enum Focus {
  ACCOUNT, // 0
  ADS, // 1
  CHANNELS_RAIL, // 2
  CHANNELS_CHOICE, // 3
  CHANNEL_GUIDE_LOGO, // 4
  CHANNEL_LIST, // 5
  CHANNEL_LIST_EVENTS, // 6
  CHANNEL_LIST_UPGRADE, // 7
  DETAIL_BUTTONS, // 8
  DETAIL_RELATED, // 9
  DETAIL_SYNOPSIS, // 10
  DISK, // 11
  FLOATING_MENU, // 12
  FILTER_RAIL, // 13
  LANGUAGES, // 14
  LIST_BUTTONS, // 15
  LOGIN, // 16
  LOGOUT, // 17
  MAIN_EMPTY, // 18
  MANAGE_CHANNELS_BUTTONS, // 19
  MENU, // 20
  MODAL_BUTTONS, // 21
  MODAL_INPUT, // 22
  MODAL_LANGUAGE_AUDIO, // 23
  MODAL_LANGUAGE_SUBTITLES, // 24
  MODAL_ZOOM, // 25
  MOSAIC, // 26
  NEXT_EPISODE, // 27
  PAUSE_ADS, // 28
  PLAYER, // 29
  POWER_SAVING, // 30
  PROMO, // 31
  QUERY_LIST, // 32
  RAILS_LIST, // 33
  RAILS_SUB_LIST, // 34
  SEARCH, // 35
  SEARCH_FILTER, // 36
  SEARCH_KEYBOARD, // 37
  SLIDER_LIST, // 38
  SLIDER_SUB_LIST, // 39
  SLIDERS, // 40
  SPLASH, // 41
  SUPPORT, // 42
  WEBVIEW, // 43
  ZAPPER, // 44
  ZAPPER_HINT, // 45
}

export default Focus;
